import styled from 'styled-components'
import { lightGray, blue, mildGray } from '../../styles/variables.js'

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
`
const Title = styled.div`
  font-size: 40px;
  letter-spacing: 0.08;
  color: ${lightGray};
  @media (max-width: 1120px) {
    font-size: 30px;
  }
`
const Logo = styled.div`
  position: absolute;
  right: 0;

  img {
    height: 80px;

    @media (max-width: 1120px) {
      height: 40px;
    }
  }
`

const Logout = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 10px;
  bottom: -65px;
  color: ${mildGray};

  & > * {
    margin-left: 5px;
  }

  a {
    text-decoration: none;
    color: ${blue} !important;
    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 1120px) {
    bottom: -50px;
  }
`

export default {
  Header,
  Title,
  Logo,
  Logout,
}
